import { render, staticRenderFns } from "./Step6_TransactionSummary.vue?vue&type=template&id=987dc51e"
import script from "./Step6_TransactionSummary.vue?vue&type=script&lang=js"
export * from "./Step6_TransactionSummary.vue?vue&type=script&lang=js"
import style0 from "./Step6_TransactionSummary.vue?vue&type=style&index=0&id=987dc51e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports